import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 0C6.5 0 2 4.5 2 10V14.5V15.9V18.5C2 19.3 2.7 20 3.5 20H4.5C5.3 20 6 19.3 6 18.5V14.5C6 13.7 5.3 13 4.5 13H3.5C3.3 13 3.2 13 3 13.1V10C3 5 7 1 12 1C17 1 21 5 21 10V13.1C20.8 13 20.7 13 20.5 13H19.5C18.7 13 18 13.7 18 14.5V18.5C18 19.3 18.7 20 19.5 20H20.5C20.7 20 20.8 20 21 19.9V20.5C21 21.9 19.9 23 18.5 23H14.5C14.2 23 14 23.2 14 23.5C14 23.8 14.2 24 14.5 24H18.5C20.4 24 22 22.4 22 20.5V18.5V18.1V16.5V14.5V10C22 4.5 17.5 0 12 0ZM3.5 14H4.5C4.8 14 5 14.2 5 14.5V18.5C5 18.8 4.8 19 4.5 19H3.5C3.2 19 3 18.8 3 18.5V15.9V14.5C3 14.2 3.2 14 3.5 14ZM21 18.5C21 18.8 20.8 19 20.5 19H19.5C19.2 19 19 18.8 19 18.5V14.5C19 14.2 19.2 14 19.5 14H20.5C20.8 14 21 14.2 21 14.5V16.5V18.1V18.5Z",
		fill: "#F5F4F3"
	})
});
export default SvgSupport;
